import { IMicrofrontendManifest } from './microfrontendManifest';

export enum EManifestStatus {
  Initial,
  Loading,
  Success,
  Fail,
}

export type TChatbotFiltersModalState = {
  isOpened: boolean;
  jsonQuery: object;
  manifest: IMicrofrontendManifest | null;
  manifestStatus: EManifestStatus;
  isFiltersLoading: boolean;
};
